import axios from "axios"

export const deleteCommission = {
  async deleteCommission({ commit }, commissionId) {
    const response = await axios.delete(`stores/commission-rate/${commissionId}`)
  }
}
